(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Threestrap", [], factory);
	else if(typeof exports === 'object')
		exports["Threestrap"] = factory();
	else
		root["Threestrap"] = factory();
})(self, function() {
return 